import { Component, ComponentFactoryResolver, NgZone, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalConstants } from '../iwgcommon/global-constants';
import { ListComponent } from '../iwgcommon/list/list.component';
import { AssignmentService } from '../shared/services/assignment.service';
import { NavbarService } from '../shared/services/navbar.service';
import { UserService } from '../shared/services/user.service';
import { Utils } from '../shared/utils/utils';
import { ListSearchParams } from '../shared/models/listsearchparams.model';
import { QuotesService } from '../shared/services/quotes.service';
import { AssignmentDialogService } from '../shared/services/assignment-dialog.service';
import { QuotesDialogComponent } from './quotes-dialog/quotes-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { CsvDataService } from '../shared/services/csv-export.service';
import { catchError } from 'rxjs/operators';
import { IWGSharedService } from '../shared/services/shared.service';

@Component({
  selector: 'app-quotes',
  templateUrl: './quotes.component.html',
  styleUrls: ['./quotes.component.scss']
})
export class QuotesComponent extends ListComponent implements OnInit {

  activeiconcolor = 'quotes';

  selectedService = 1;
  selectedServiceName: string;
  ShowEOREstimator = false;
  labelPlural = '';
  ShowQuotesButton = false;
  sub: any;
  state: ListSearchParams;

  allowEndClients = false;
  USEORDisabled = false;
  
  USComplianceDisabled = false;
  USAORDisabled = false;
  InternationalEORDisabled = false;
  InternationalComplianceDisabled = false;
  InternationalAORDisabled = false;
  ShowEngageButton = false;
  showCompliance = false;
  labelSingular = '';
  exportColDetails: any;
  exportUSDetails: any;
  globalScopes: any;
  hideColsInExport: number[];

  EORDisabled = false;
  ComplianceDisabled = false;
  AORDisabled = false;

  ShowEORQuotes = true;
  ShowComplianceQuotes = true;
  ShowAORQuotes = true;
   
    isService: boolean = false;

    showFooter = true;
    embedStatus = "notembed";  

  constructor(private router: Router, utils: Utils, userService: UserService,
              public nav: NavbarService, renderer: Renderer2, public route: ActivatedRoute, 
              quotesService: QuotesService, zone: NgZone, private assignmentDialogService: AssignmentDialogService, 
              public dialog: MatDialog,private quoteService: QuotesService, private csvDataService: CsvDataService,public sharedService: IWGSharedService) {
        super(quotesService, utils, renderer, userService, zone,sharedService);
        this.globalScopes = GlobalConstants.globalScopes;

        this.router.routeReuseStrategy.shouldReuseRoute = (): boolean => {
        return false;
      };
}

  //ngOnInit(): void {
    
  //  this.nav.show();
  //  this.nav.setActiveMenu('services');
  //  this.nav.setActiveModuleMenu({'isVisible':true, 'activeMenu':'services'});
  //  this.state = {limit: 25, page: 1, service: 1, global_scope: 1, country: -1, isUSA: false};

  //  this.route.queryParams.subscribe(params => {
  //    if (params) {
  //      this.selectedService = +params.service;
        
  //      this.state = Object.assign({}, this.state, (params));
  //      if (!this.state.service) {
  //        this.state.service = 1;
  //      }
  //      if (params.start) {
  //        this.state.start = new Date(params.start);
  //      }
  //      if (params.end) {
  //        this.state.end = new Date(params.end);
  //      }
  //      // this.state.country = parseInt('' + this.state.country);

  //    }
  //  });

  //  super.ngOnInit();
  //  this.selectedServiceName = this.utils.getServiceName(this.selectedService);
  //  this.service = this.selectedService;
  //  this.allowEndClients = this.userService.getAllowEndClients();

  //  if (this.userService.getEOREstimatorAccess() && this.userService.getRole() !== 'Worker') {
  //    this.ShowEOREstimator = true;
  //  } else {
  //    this.ShowEOREstimator = false;
  //  }

  //  if(this.userService.getRole() == 'Worker') {
  //    this.ShowEORQuotes = false;
  //    this.ShowComplianceQuotes = false;
  //    this.ShowAORQuotes = false;
  //  }

  //  this.USEORDisabled = this.userService.getUSEORDisabled();
  //  this.USComplianceDisabled = this.userService.getUSComplianceDisabled();
  //  this.USAORDisabled = this.userService.getUSAORDisabled();
  //  this.InternationalEORDisabled = this.userService.getInternationalEORDisabled();
  //  this.InternationalComplianceDisabled = this.userService.getInternationalComplianceDisabled();
  //  this.InternationalAORDisabled = this.userService.getInternationalAORDisabled();

  //  this.ShowQuotesButton = !this.userService.getNewQuotesDisabled();
  //  this.ShowEngageButton = !this.userService.getNewEngageDisabled();
  //  this.showCompliance = !this.userService.getEvaluateButtonDisabled();

  //  this.EORDisabled = this.userService.getEORDisabled();
  //  this.ComplianceDisabled = this.userService.getComplianceDisabled();
  //  this.AORDisabled = this.userService.getAORDisabled();

  //  this.selectedServiceName = this.utils.getServiceName(this.selectedService);
  //  if (this.selectedServiceName === 'Employer of Record') {
  //      this.labelSingular = 'Assignment';
  //  }
  //  else if (this.selectedServiceName === 'Agent of Record') {
  //      this.labelSingular = 'Engagement';
  //  }
  //  else if (this.selectedServiceName === 'Compliance') {
  //      this.labelSingular = 'Evaluation';
  //  }
  //  this.labelPlural = this.labelSingular + 's';

  //  this.listColumns = ['QuoteID', 'Title', 'EndClient', 'JobTitle', 'Location', 'StatusName', 'WorkerCount',
  //    'DateRequested', 'Expiration', 'Price', 'ClientMarkup', 'SalesTax', 'OprMenu'];

  //    this.generateListColumns();
  //    this.setStateParams();
  //    this.getItems();

  //    this.exportColDetails = {
  //      'QuoteID': {'heading': 'Reference ID', 'dataFieldName': 'QuoteID'}, 
  //      'Title': { 'heading': 'Quote', 'dataFieldName': 'Title', 'dataFormat': 'htmDecode'}, 
  //      'Service': {'heading': 'Service', 'dataFieldName': 'Service'}, 
  //      'EndClient': {'heading': 'End Client', 'dataFieldName': 'EndClientName'}, 
  //      'JobTitle': { 'heading': 'Job Title', 'dataFieldName': 'JobTitle', 'dataFormat': 'htmDecode'}, 
  //      'Location': {'heading': 'Country', 'dataFieldName': 'Country', "dataFormat": "countryRegion"}, 
  //      'StatusName': {'heading': 'Status', 'dataFieldName': 'Status'}, 
  //      'WorkerCount': {'heading': 'Workers', 'dataFieldName': 'NumberOfWorkers'}, 
  //      'DateRequested': {'heading': 'Submitted', 'dataFieldName': 'DateRequested', 'dataFormat': 'date', 'dateFormat': 'MMM d, y'}, 
  //      'Expiration': {'heading': 'Expiration', 'dataFieldName': 'QuoteExpirationDate', 'dataFormat': 'date', 'dateFormat': 'MMM d, y'}, 
  //       'Price': { 'heading': 'Price', 'dataFieldName': 'EstimatedMonthlyInvoiceUSD', 'dataFormat': 'formattedUSandClientMarkup', 'currencyCodeField': 'EntityCurrencyCode'}, 
  //      'ClientMarkup': {'heading': 'Markup (%)', 'dataFieldName': 'ClientMarkup', 'dataFormat': 'percentToFixed'}, 
  //      'SalesTax': {'heading': 'Sales Tax (%)', 'dataFieldName': 'SalesTax', 'dataFormat': 'percentToFixed'}
  //    } 
  //}

    ngOnInit(): void {
        var isEmbed = this.sharedService.getIsEmbed();
        if (isEmbed === true) {
            this.embedStatus = "embed";
            this.nav.show(isEmbed);      
            history.pushState(null, null, null);
            window.addEventListener('popstate', () => {
                history.pushState(null, null, null);
            });
            this.showFooter = false;
        }
        else {
            this.showFooter = true;
            this.embedStatus = "notembed";
            this.nav.show(); 
            this.nav.setActiveMenu('services');
            this.nav.setActiveModuleMenu({ 'isVisible': true, 'activeMenu': 'services' });
        }
       
        this.state = { limit: 25, page: 1, service: 1, global_scope: 1, country: -1, isUSA: false };

        this.route.queryParams.subscribe(params => {
            if (params) {
                this.selectedService = +params.service;

                this.state = Object.assign({}, this.state, (params));
                if (!this.state.service) {
                    this.state.service = 1;
                }
                if (params.start) {
                    this.state.start = new Date(params.start);
                }
                if (params.end) {
                    this.state.end = new Date(params.end);
                }
                // this.state.country = parseInt('' + this.state.country);

            }
        });

        super.ngOnInit();
        this.selectedServiceName = this.utils.getServiceName(this.selectedService);
        this.service = this.selectedService;
        this.allowEndClients = this.userService.getAllowEndClients();

        if (this.userService.getEOREstimatorAccess() && this.userService.getRole() !== 'Worker') {
            this.ShowEOREstimator = true;
        } else {
            this.ShowEOREstimator = false;
        }

        if (this.userService.getRole() == 'Worker') {
            this.ShowEORQuotes = false;
            this.ShowComplianceQuotes = false;
            this.ShowAORQuotes = false;
        }

        this.USEORDisabled = this.userService.getUSEORDisabled();
        this.USComplianceDisabled = this.userService.getUSComplianceDisabled();
        this.USAORDisabled = this.userService.getUSAORDisabled();
        this.InternationalEORDisabled = this.userService.getInternationalEORDisabled();
        this.InternationalComplianceDisabled = this.userService.getInternationalComplianceDisabled();
        this.InternationalAORDisabled = this.userService.getInternationalAORDisabled();

        this.ShowQuotesButton = !this.userService.getNewQuotesDisabled();
        this.ShowEngageButton = !this.userService.getNewEngageDisabled();
        this.showCompliance = !this.userService.getEvaluateButtonDisabled();

        this.EORDisabled = this.userService.getEORDisabled();
        this.ComplianceDisabled = this.userService.getComplianceDisabled();
        this.AORDisabled = this.userService.getAORDisabled();

        this.selectedServiceName = this.utils.getServiceName(this.selectedService);
        if (this.selectedServiceName === 'Employer of Record') {
            this.labelSingular = 'Assignment';
        }
        else if (this.selectedServiceName === 'Agent of Record') {
            this.labelSingular = 'Engagement';
        }
        else if (this.selectedServiceName === 'Compliance') {
            this.labelSingular = 'Evaluation';
        }
        this.labelPlural = this.labelSingular + 's';

        this.listColumns = ['QuoteID', 'Title', 'EndClient', 'JobTitle', 'Location', 'StatusName', 'WorkerCount',
            'DateRequested', 'Expiration', 'Price', 'ClientMarkup', 'SalesTax', 'OprMenu'];

        this.generateListColumns();
        this.setStateParams();
        this.getItems();

        this.exportColDetails = {
            'QuoteID': { 'heading': 'Reference ID', 'dataFieldName': 'QuoteID' },
            'Title': { 'heading': 'Quote', 'dataFieldName': 'Title', 'dataFormat': 'htmDecode' },
            'Service': { 'heading': 'Service', 'dataFieldName': 'Service' },
            'EndClient': { 'heading': 'End Client', 'dataFieldName': 'EndClientName' },
            'JobTitle': { 'heading': 'Job Title', 'dataFieldName': 'JobTitle', 'dataFormat': 'htmDecode' },
            'Location': { 'heading': 'Country', 'dataFieldName': 'Country', "dataFormat": "countryRegion" },
            'StatusName': { 'heading': 'Status', 'dataFieldName': 'Status' },
            'WorkerCount': { 'heading': 'Workers', 'dataFieldName': 'NumberOfWorkers' },
            'DateRequested': { 'heading': 'Submitted', 'dataFieldName': 'DateRequested', 'dataFormat': 'date', 'dateFormat': 'MMM d, y' },
            'Expiration': { 'heading': 'Expiration', 'dataFieldName': 'QuoteExpirationDate', 'dataFormat': 'date', 'dateFormat': 'MMM d, y' },
            'Price': { 'heading': 'Price', 'dataFieldName': 'EstimatedMonthlyInvoiceUSD', 'dataFormat': 'formattedUSandClientMarkup', 'currencyCodeField': 'EntityCurrencyCode' },
            'ClientMarkup': { 'heading': 'Markup (%)', 'dataFieldName': 'ClientMarkup', 'dataFormat': 'percentToFixed' },
            'SalesTax': { 'heading': 'Sales Tax (%)', 'dataFieldName': 'SalesTax', 'dataFormat': 'percentToFixed' }
        }
    }

  generateListColumns(): void {

    this.displayedColumns = [...this.listColumns];


    if (!this.userService.getAllowEndClients()) {
      this.removeColFromDisplay('EndClient');
    }

    if (this.service != 1) {
      this.removeColFromDisplay('JobTitle');
      this.removeColFromDisplay('WorkerCount');
      this.removeColFromDisplay('Expiration');
    }

    if (this.service == 2) {
      this.removeColFromDisplay('Price');
    } else {
      this.removeColFromDisplay('ClientMarkup');
      this.removeColFromDisplay('SalesTax');

    }

    }
    
  showQuoteEstimator = (ev) => {
    this.router.navigate(["/quoteEstimator/7b57522b-d0d6-403c-b524-1f0e2f24003c"], 
      {queryParams:{service: this.state.service, global_scope: this.state.service}});

  }

  showAssignmentDialog = (ev, quoteId, serviceId) => {    
    this.assignmentDialogService.show(ev, null, quoteId, null, null, serviceId);
  }
  show(ev,data,quoteId){
    this.sharedService.isBlurredBg.next(true);
    const dialogRef = this.dialog.open( QuotesDialogComponent, {
      panelClass: 'iwg-form-dialogfull',
      data: {existingQuote:data}
    });
    dialogRef.afterClosed().subscribe( result => {
      this.generateListColumns();
      this.setStateParams();
      this.getItems();
      this.sharedService.isBlurredBg.next(false);            
    });
  }
  showTransferAssignmentDialog = (ev, quoteId) => {
    if (quoteId) {
    this.quoteService.getQuotesById(quoteId).pipe(catchError((err) => {      
      throw (err);
  })).subscribe(quote => {
    this.show(ev, quote.data.Data,quoteId)
  });
    }else{
      this.show(ev, null, null)
    }
    };

    exportTable() {
        let exportColList = [];

        if (this.service == 2) {
            exportColList = ['QuoteID', 'Title', 'Service'];
            if (this.userService.getAllowEndClients()) {
                exportColList.push.apply(exportColList, ['EndClient']);
            }
            exportColList.push.apply(exportColList, ['Location', 'StatusName', 'DateRequested', 'ClientMarkup', 'SalesTax']);

        } else {

          if(this.service == 3){
            exportColList = ['QuoteID', 'Title', 'Service'];
            if (this.userService.getAllowEndClients()) {
                exportColList.push.apply(exportColList, ['EndClient']);
            }
            exportColList.push.apply(exportColList, ['Location', 'StatusName', 'DateRequested', 'Price']);
          }else{
            exportColList = ['QuoteID', 'Title', 'Service'];
            if (this.userService.getAllowEndClients()) {
                exportColList.push.apply(exportColList, ['EndClient']);
            }
            exportColList.push.apply(exportColList, ['JobTitle', 'Location', 'StatusName', 'WorkerCount', 'DateRequested',
                'Expiration', 'Price']);
          }
        }
        this.csvDataService.exportToCsv("quotes.csv", this.items, this.exportColDetails, exportColList, this.service);
    }
    ShowQuoteDialog_embed = (ev) => {
        this.displayQuoteDialog(ev);
    }

    displayQuoteDialog = (ev) => {
        this.sharedService.isBlurredBg.next(true);
        const dialogRef = this.dialog.open(QuotesDialogComponent, {
            panelClass: 'iwg-form-dialogfull',
            autoFocus: false,
            data: { existingQuote: null }
        });
        dialogRef.afterClosed().subscribe(result => {
            this.sharedService.isBlurredBg.next(false);
        });
    }
}